import { render, staticRenderFns } from "./AutoStockInfo.vue?vue&type=template&id=6a54a63b&scoped=true"
import script from "./AutoStockInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoStockInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AutoStockInfo.vue?vue&type=style&index=0&id=6a54a63b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54a63b",
  null
  
)

export default component.exports